import type { AlertInput } from "@/lib/api/alerts";
import { calendarDateInTimeZone, calendarTimeToUTC } from "@/lib/display-time";
import type { Alert } from "@/types/api";

export function scheduledAlertForDisplay(
  alert: Alert,
  timeZone: string,
): Alert {
  const condition = alert.condition;
  if (alert.type !== "scheduled" || typeof condition.date !== "string")
    return alert;
  const sourceZone =
    typeof condition.time_zone === "string"
      ? condition.time_zone
      : "America/New_York";
  const [hour, minute] = (
    typeof condition.time === "string" ? condition.time : "09:30"
  )
    .split(":")
    .map(Number);
  let instant: Date;
  try {
    instant = calendarTimeToUTC(condition.date, sourceZone, hour, minute);
  } catch {
    return alert;
  }
  if (!Number.isFinite(instant.getTime())) return alert;
  const time = new Intl.DateTimeFormat("en-GB", {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(instant);
  return {
    ...alert,
    condition: {
      ...condition,
      date: calendarDateInTimeZone(instant, timeZone).dateStr,
      time,
      time_zone: timeZone,
    },
  };
}

export function scheduledAlertInput(
  input: AlertInput,
  timeZone: string,
  existingType?: string,
): AlertInput {
  if (
    !input.condition ||
    (input.type ?? existingType ?? input.condition.type) !== "scheduled"
  )
    return input;
  return { ...input, condition: { ...input.condition, time_zone: timeZone } };
}
